import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'detect-autofill'
import 'webcrypto-shim'

import MenuManager from 'Modules/MenuManager'
import FloatingLabels from 'Modules/FloatingLabels'
import { openRedirectPopupLayer } from 'Components/redirect-popup/redirect-popup.utils'
import yTosOverrides from './utils/Overrides'
import fetchWrapper from './utils/Fetch'
import Tracking from './utils/Tracking'
import { yTosDebug, trace } from './utils/Debug'
import { loadPage, loadWebComponents } from './utils/LoadResources'
import { initLazyLoad, setLazyloadF31Configuration } from './utils/Lazyload'
import {
	setViewportHeightCssVariable,
	isIOS,
	setCultureFor500,
	isSafari,
	moveCookieLayerToPopup,
} from './utils/Utility'
import { requestIdleCallbackShim, loadScrollBehaviorPolyfill } from './utils/Polyfill'
import Datalayer from './modules/Datalayer'
import { setLayerConfiguration, popup } from './modules/Popup'
import Devices from './modules/Device'
import Overlay from './modules/Overlay'
import UIScaleAccessibility from './modules/UIScaleAccessibility'
import SelectNativeFixFocus from './modules/SelectNativeFocusFix'
import Loader from './modules/Loader'
import mPulse from './modules/MPulse'

// Polyfills
requestIdleCallbackShim()
loadScrollBehaviorPolyfill()

yTosDebug()
yTosOverrides()
const dataLayer = new Datalayer()
yTos.Cartier.devices = new Devices()
yTos.Cartier.overlay = new Overlay()
yTos.Cartier.loader = new Loader()
yTos.Cartier.tracking = new Tracking()
yTos.Cartier.popup = popup
yTos.Cartier.trace = trace
yTos.mPulse = mPulse
yTos.fetch = fetchWrapper
yTos.Cartier.isIOS = isIOS
yTos.Cartier.isSafari = isSafari
new MenuManager()
new UIScaleAccessibility()
new FloatingLabels()

setCultureFor500()

const init = async () => {
	let pageInstance = null
	const { initHelpers } = await yTos.helpers.initSite()
	const [pageModule] = await Promise.all([loadPage(), loadWebComponents()])

	if (pageModule) {
		const PageClass = pageModule.default
		pageInstance = new PageClass()
	}

	dataLayer.defineDataLayerFilter(pageInstance)

	yTos.ready = true
	initHelpers()

	if (yTos.Cartier.isIOS()) new SelectNativeFixFocus()
	setViewportHeightCssVariable()
	initLazyLoad()
	setLayerConfiguration()
	setLazyloadF31Configuration()
	openRedirectPopupLayer()
	moveCookieLayerToPopup()
}

init()
